import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {EEquipmentType, equipmentsTranslateKey} from "../../../../models/utils/EEquipmentType";
import ValidationItem from "../ValidationItem";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    equipmentType: EEquipmentType
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class EquipmentType extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <ValidationItem label={getTranslation("steps.validation.labels.equipment-type")}>
                {getTranslation(equipmentsTranslateKey[this.props.equipmentType])}
            </ValidationItem>

        );

    };

}

export default withTranslation()(EquipmentType);
